import {
  loginUserRequestActionCreator,
  loginUserSuccessActionCreator,
  loginUserFailureActionCreator,
  logoutUserActionCreator,
  getCurrentUserSuccessActionCreator,
  getCurrentUserRequestActionCreator,
  getCurrentUserFailureActionCreator,
  updateUserProfileRequestActionCreator,
  updateUserProfileSuccessActionCreator,
  updateUserProfileFailureActionCreator,
  getTermsRequestActionCreator,
  addBankAccountSuccessActionCreator,
  fetchBankAccountSuccessActionCreator,
  fetchCreditCardSuccessActionCreator,
  addCreditCardSuccessActionCreator,
  deleteBankAccountSuccessActionCreator,
  deleteCreditCardSuccessActionCreator,
  changeDefaultCreditCardSuccessActionCreator,
  fetchCreditCardRequestActionCreator,
  fetchCreditCardFailureActionCreator,
  toggleSubscribeUserSuccessActionCreator,
  getPrivacyRequestActionCreator,
  fetchNotificationCountSuccessActionCreator,
  fetchCountryListdRequestActionCreator,
  fetchCountryListSuccessActionCreator,
  fetchStateListdRequestActionCreator,
  fetchStateListSuccessActionCreator
} from './auth.actionCreators';
import API from '../../API';
import { removeToken, setToken } from '../../helpers';

export const loginUser = params => {
  return async dispatch => {
    dispatch(loginUserRequestActionCreator());
    return await API.post('/auth/login', params)
      .then(resp => {
        const { user, token } = resp;
        setToken(token.access_token);
        dispatch(loginUserSuccessActionCreator(user));
        // email verification
        // if(resp.user.email_verified_at){
        // }
        // else{
        //   alert('We have sent you an e-mail to activate your account. Please activate your account to log in')
        //   return
        // }
        return resp;
      })
      .catch(err => {
        dispatch(loginUserFailureActionCreator());
        throw err;
      });
  };
};
export const getCurrentUser = () => {
  return async dispatch => {
    dispatch(getCurrentUserRequestActionCreator());
    return await API.post('/auth/me')
      .then(resp => {
        dispatch(getCurrentUserSuccessActionCreator(resp));
        return resp;
      })
      .catch(err => {
        dispatch(getCurrentUserFailureActionCreator());
        removeToken();
        return err;
      });
  };
};

export const fetchTerms = () => {
  return async dispatch => {
    dispatch(fetchCreditCardRequestActionCreator());
    return await API.get('/page/terms')
      .then(resp => {

        dispatch(getTermsRequestActionCreator(resp));
        return resp;
      })
      .catch(err => {
        dispatch(getTermsRequestActionCreator());
        throw err;
      });
  };
};
export const registerUser = params => {
  return async dispatch => {
    dispatch(loginUserRequestActionCreator());
    return await API.post('/register', params)
      .then(resp => {
        const { user, token } = resp;
        setToken(token.access_token);
        dispatch(loginUserSuccessActionCreator(user));
        return resp;
      })
      .catch(err => {
        dispatch(loginUserFailureActionCreator());
        throw err;
      });
  };
};
export const updateUserProfile = (id, params) => {
  console.log('updateUserProfile', id, params);

  return async dispatch => {
    dispatch(updateUserProfileRequestActionCreator());
    return await API.post(`/users/${id}/update`, params, true)
      .then(resp => {
        dispatch(updateUserProfileSuccessActionCreator(resp));
        return resp;
      })
      .catch(err => {
        dispatch(updateUserProfileFailureActionCreator());
        throw err;
      });
  };
};
export const fetchPrivacy = () => {
  return async dispatch => {
    return await API.get('/page/privacy')
      .then(resp => {
        dispatch(getPrivacyRequestActionCreator(resp));
        return resp;
      })
      .catch(err => {
        dispatch(getPrivacyRequestActionCreator());
        throw err;
      });
  };
};
// export const addBankAccount = params => {
//   return async dispatch => {
//     return await API.post('bank-accounts', params, true)
//       .then(resp => {
//         dispatch(addBankAccountSuccessActionCreator(resp));
//         return resp;
//       })
//       .catch(err => {
//         throw err;
//       });
//   };
// };

export const fetchBankAccounts = () => {
  console.log('bank');
  return async dispatch => { 
    return await API.get(`payments/vendor`)
      .then(resp => {
        dispatch(fetchBankAccountSuccessActionCreator(resp));
        return resp;

      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  };
};

// export const deleteBankAccount = id => {
//   return async dispatch => {
//     return await API.delete(`bank-accounts/${id}`)
//       .then(resp => {
//         dispatch(deleteBankAccountSuccessActionCreator(id));
//         return resp;
//       })
//       .catch(err => {
//         throw err;
//       });
//   };
// };


export const addCreditCard = params => {
  return async dispatch => {
    return await API.post(`payments/credit-cards`, params)
      .then(resp => {
        dispatch(addCreditCardSuccessActionCreator(resp));
        return resp;
      })
      .catch(err => {
        throw err;
      });
  };
};


export const fetchCreditCards = () => {
  return async dispatch => {
    dispatch(fetchCreditCardRequestActionCreator());
    return await API.get(`payments/credit-cards`)
      .then(resp => {
        dispatch(fetchCreditCardSuccessActionCreator(resp));
        return resp;
      })
      .catch(err => {
        dispatch(fetchCreditCardFailureActionCreator());
        throw err;
      });
  };
};

export const fetchCountryList = () => {
  return async dispatch => {
    dispatch(fetchCountryListdRequestActionCreator());
    return await API.get(`countries`)
      .then(resp => {
        dispatch(fetchCountryListSuccessActionCreator(resp))
       console.log(resp);
        return resp;
      })
      .catch(err => {
      
        throw err;
      });
  };
};

export const fetchStateList = () => {
  return async dispatch => {
    dispatch(fetchStateListdRequestActionCreator());
    return await API.get(`states`)
      .then(resp => {
        dispatch(fetchStateListSuccessActionCreator(resp))
       console.log(resp);
        return resp;
      })
      .catch(err => {
      
        throw err;
      });
  };
};



export const addBankAccount = params => async dispatch => {
    return await API.put(`payments/vendor`, params)
      .then(resp => {
        dispatch(addBankAccountSuccessActionCreator(resp));
        console.log(resp,'response')
        return resp;
      })
      .catch(err => {
console.log(err,'errr');
        throw err;
      });
  };



export const toggleUserSubscription = () => {
  return async dispatch => {
    return await API.post(`user/subscribe/toggle`)
      .then(resp => {
        dispatch(toggleSubscribeUserSuccessActionCreator(Number(resp.subscribed)));
        return resp;
      })
      .catch(err => {
        throw err;
      });
  };
};

export const getNotifications = id => {
  return async dispatch => {
    return await API.get(`notifications`)
      .then(resp => {
        return resp;
      })
      .catch(err => {
        throw err;
      });
  };
};

export const getNotificationsCount = () => {
  return async dispatch => {
    return await API.get(`/notifications/totals`)
      .then(resp => {
        dispatch(fetchNotificationCountSuccessActionCreator(resp));
        return resp;
      })
      .catch(err => {
        throw err;
      });
  };
};

export const getProfiles = id => {
  return async dispatch => {
    return await API.get(`profiles/${id}`)
      .then(resp => {
        return resp;
      })
      .catch(err => {
        throw err;
      });
  };
};
export const getProfilePosts = id => {
  return async dispatch => {
    return await API.get(`posts/${id}`)
      .then(resp => {
        return resp;
      })
      .catch(err => {
        throw err;
      });
  };
};

export const deleteCreditCard = id => {
  return async dispatch => {
    return await API.delete(`payments/credit-cards/${id}`)
      .then(resp => {
        dispatch(deleteCreditCardSuccessActionCreator(id));
        return resp;
      })
      .catch(err => {
        throw err;
      });
  };
};
export const changeDefaultCreditCard = id => {
  return async dispatch => {
    return await API.post(`payments/credit-cards/${id}`)
      .then(resp => {
        dispatch(changeDefaultCreditCardSuccessActionCreator(id));
        return resp;
      })
      .catch(err => {
        throw err;
      });
  };
};
export const logoutUser = () => {

  return async dispatch => {
    return await API.post(`/auth/logout`)
      .then(resp => {
        dispatch(logoutUserActionCreator());

        return resp;
      })
      .catch(err => {
        throw err;
      });
  };
};
